<div class="lp-app-layout">
  @if (isLoggedIn()) {
    <dm-sidebar-provider #sidebarProvider (dmOpenChange)="sidebarExpanded.set($event.detail)">
      <lp-sidebar-navigation [collapsed]="!sidebarExpanded()" (closeMobileSidebar)="onCloseMobileSidebar()" />
      <dm-sidebar-inset>
        <dm-sidebar-mobile-header>
          <lp-logo slot="logo" variant="full" appearance="on-brand" />
          <span slot="logo" class="lp-app-layout__brand-badge">ADMIN</span>
        </dm-sidebar-mobile-header>
        <router-outlet />
      </dm-sidebar-inset>
    </dm-sidebar-provider>
  } @else {
    <router-outlet />
  }
  <dm-toaster position="bottom-right" />
  <lp-confirm-dialog />
</div>
